import { BiconomySmartAccountV2 } from '@biconomy/account';
import { AccountAbstractionActionTypes } from './AccountAbstractionContext';

export enum SESSION_KEYS {
  JOIN_TABLE_SESSION = 'joinTableBatchSessionIDInfo',
  REBUY_TABLE_SESSION = 'rebuyBatchSessionIDInfo',
  REDEEM_SESSION = 'redeemBatchSessionIDInfo',
}

export const setSmartAccount = (smartAccount: BiconomySmartAccountV2) => ({
  type: AccountAbstractionActionTypes.SET_SMART_ACCOUNT,
  payload: smartAccount,
});

export const setSmartAccountAddress = (address: string) => ({
  type: AccountAbstractionActionTypes.SET_SMART_WALLET_ADDRESS,
  payload: address,
});

export const setLoading = (loading: boolean) => ({
  type: AccountAbstractionActionTypes.SET_LOADING,
  payload: loading,
});

export const setLoadingJoinTableSession = (loading: boolean) => ({
  type: AccountAbstractionActionTypes.SET_LOADING_JOIN_TABLE_SESSION,
  payload: loading,
});

export const setLoadingRebuySession = (loading: boolean) => ({
  type: AccountAbstractionActionTypes.SET_LOADING_REBUY_SESSION,
  payload: loading,
});

export const setLoadingRedeemSession = (loading: boolean) => ({
  type: AccountAbstractionActionTypes.SET_LOADING_REDEEM_SESSION,
  payload: loading,
});

export const setLoadingTransaction = (loading: boolean) => ({
  type: AccountAbstractionActionTypes.SET_LOADING_TRANSACTION,
  payload: loading,
});

export const setInitialized = (initialized: boolean) => ({
  type: AccountAbstractionActionTypes.SET_INITIALIZED,
  payload: initialized,
});

export const setSessionKey = (sessionKey: any) => ({
  type: AccountAbstractionActionTypes.SET_SESSION_KEY,
  payload: sessionKey,
});

export const setSessionStorageClient = (sessionStorageClient: any) => ({
  type: AccountAbstractionActionTypes.SET_SESSION_STORAGE_CLIENT,
  payload: sessionStorageClient,
});

export const setJoinTableBatchSession = (session: any) => {
  // save session in local storage
  localStorage.setItem(SESSION_KEYS.JOIN_TABLE_SESSION, JSON.stringify(session.sessionIDInfo));
  return {
    type: AccountAbstractionActionTypes.SET_JOIN_TABLE_BATCH_SESSION,
    payload: session,
  };
};
export const setRebuyBatchSession = (session: any) => {
  // save session in local storage
  localStorage.setItem(SESSION_KEYS.REBUY_TABLE_SESSION, JSON.stringify(session.sessionIDInfo));
  return {
    type: AccountAbstractionActionTypes.SET_REBUY_BATCH_SESSION,
    payload: session,
  };
};
export const setRedeemBatchSession = (session: any) => {
  // save session in local storage
  localStorage.setItem(SESSION_KEYS.REDEEM_SESSION, JSON.stringify(session.sessionIDInfo));
  return {
    type: AccountAbstractionActionTypes.SET_REDEEM_BATCH_SESSION,
    payload: session,
  };
};

export const setEmulatedSmartAccount = (emulatedSmartAccount: any) => ({
  type: AccountAbstractionActionTypes.SET_EMULATED_SMART_ACCOUNT,
  payload: emulatedSmartAccount,
});

export const deleteSessions = () => {
  localStorage.removeItem(SESSION_KEYS.JOIN_TABLE_SESSION);
  localStorage.removeItem(SESSION_KEYS.REBUY_TABLE_SESSION);
  localStorage.removeItem(SESSION_KEYS.REDEEM_SESSION);
  return { type: AccountAbstractionActionTypes.DELETE_SESSIONS };
};

export const deleteJoinTableSession = () => {
  localStorage.removeItem(SESSION_KEYS.JOIN_TABLE_SESSION);
  return { type: AccountAbstractionActionTypes.DELETE_JOIN_TABLE_SESSION };
};

export const deleteRebuySession = () => {
  localStorage.removeItem(SESSION_KEYS.REBUY_TABLE_SESSION);
  return { type: AccountAbstractionActionTypes.DELETE_REBUY_SESSION };
};

export const deleteRedeemSession = () => {
  localStorage.removeItem(SESSION_KEYS.REDEEM_SESSION);
  return { type: AccountAbstractionActionTypes.DELETE_REDEEM_SESSION };
};
